import Api from '@/api/index'

export default {
  data: () => ({
    // search usado na tabela
    search: null,
    // loading para indicar na tabela
    loading_data: true,
    // options para indicar na tabela como -> :options.sync="options"
    options: {},

    // items da tabela, pode usar um dentro do componente também
    api_data: [],
    // toal de items da tabela, indicar como -> :server-items-length="total_data"
    total_data: 0,

    base_filters: {
      module_name: null,
      module_action: null,
      local_data: null,
      response_key_data: null,
      response_key_totals: null,
      extra_filters: {},
    },

    default_source_kind: 'local', //['local', 'vuex']
    items: []
  }),

  mounted() {
  },

  methods: {
    setBaseFilters(module_name = '', module_action = '', local_data = '', response_key_data = '', response_key_totals = '', extra_filters = null){
      this.base_filters = {
        module_name:         module_name? module_name : this.base_filters.module_name ,
        module_action:       module_action? module_action : this.base_filters.module_action ,
        local_data:          local_data? local_data : this.base_filters.local_data ,
        response_key_data:   response_key_data? response_key_data : this.base_filters.response_key_data ,
        response_key_totals: response_key_totals? response_key_totals : this.base_filters.response_key_totals ,
        extra_filters:       extra_filters? extra_filters : this.base_filters.extra_filters ,
      }
    },
    getDataFromApi(module_name = '', module_action = '', local_data = '', response_key_data = '', response_key_totals = '', extra_filters = null) {
      /*
        module_name: Nome do modulo da api,
        module_action: Nome do metodo do modulo da api,
        local_data: Variavel do data do componente utilizado, caso deseje usar,
        response_key_data: Chave da resposta da api que contem os dados paginados,
        response_key_totals: Chave da resposta da api que contem o total de dados presentes na api
      */
      // console.log({extra_filters});
      this.setBaseFilters(module_name, module_action, local_data, response_key_data, response_key_totals, extra_filters )
      module_name          = this.base_filters.module_name
      module_action        = this.base_filters.module_action
      local_data           = this.base_filters.local_data
      response_key_data    = this.base_filters.response_key_data
      response_key_totals  = this.base_filters.response_key_totals
      extra_filters        = this.base_filters.extra_filters

      extra_filters = extra_filters || {}


      this.loading_data = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let filter = {
        page, 
        limit: itemsPerPage, 
        query: this.search || null,
        sort_field: sortBy[0] || null,
        sort_dir: sortBy[0]? (sortDesc[0]? 'desc' : 'asc') : null,
        ...extra_filters,
      }

      if(module_name){
        if (this.default_source_kind == 'vuex') {
          this.$store.dispatch(`${module_name}/${module_action}`, filter, {root: true}).then(data => {
            this.total_data = data.total
            this.loading_data = false
          })
        } else {
          Api[module_name][module_action](filter).then(response => response.data).then(data => {
            if (local_data){
              this[local_data] = data[response_key_data]
            } else {
              this.api_data = data[response_key_data]
            }
            this.total_data = data[response_key_totals]
          }).finally(()=>{
            this.loading_data = false
          })
        }
      }
    },
  },
  watch: {
    options: {
      // qualquer alteração dentro do objeto de options irá trigar esse watcher e irá executar o que está dentro de handler
      deep: true,
      handler (nv) {
        if (!this.loading_data){
          this.getDataFromApi()
        }
      },
    },
    search(nv,ov) {
      // usa o search para fazer pesquisas por texto na api, ainda não disponibilizado
      if (nv && nv.length >= 3 && !this.loading_data){
        this.options.page = 1
        this.getDataFromApi()
      } else if (nv.length == 0){
        this.options.page = 1
        this.getDataFromApi()
      }
    },
  }
};
